import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth-store';
import { useKitRegistrationStore } from '../store/kit-registration-store';

interface Props {
  children: React.ReactNode;
}

export const KitRegisterProvider: React.FC<Props> = ({ children }: Props) => {
  const navigate = useNavigate();
  const accessToken = useAuthStore((state) => state.accessToken);
  const slug = useKitRegistrationStore((state) => state.slug);
  const registerKit = useKitRegistrationStore((state) => state.registerKit);
  const isKitRegistered = useKitRegistrationStore(
    (state) => state.isKitRegistered
  );

  const uniqueId = sessionStorage.getItem('uniqueId');

  useEffect(() => {
    if (!uniqueId) {
      navigate('/register-kit');
    }
  }, [uniqueId]);

  useEffect(() => {
    if (accessToken) {
      registerKit();
    }
  }, [accessToken]);

  useEffect(() => {
    if (isKitRegistered) {
      localStorage.removeItem('product-slug');
      navigate('/register-kit/success');
    } else {
      localStorage.setItem('product-slug', slug);
    }
  }, [isKitRegistered]);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  );
};
